import "zod/compile";
import { z } from "zod";

/**
 * How a dataset value reads in a Report's text, KPIs and Tables: a surface
 * states it on a dataset column (from its own catalog), and a Table column
 * may override it. Money arrives as a decimal string and stays one; only
 * its display rounds.
 *
 * - `count`: a whole number, grouped (1,234).
 * - `number`: a plain number.
 * - `money`: US dollars ($1,234.56).
 * - `percent`: a fraction from 0 to 1, shown as a whole percent (0.25 → 25%).
 * - `percent100`: a 0–100 percentage (25 → 25%).
 * - `days`: a number of days, to one decimal.
 * - `day`: a calendar day (YYYY-MM-DD), shown in the medium date style.
 * - `date`: a timestamp, shown as its date.
 * - `text`: as written.
 */
export const REPORT_VALUE_FORMATS = [
  "text",
  "count",
  "number",
  "money",
  "percent",
  "percent100",
  "days",
  "day",
  "date",
] as const;
export const ReportValueFormatSchema = z.enum(REPORT_VALUE_FORMATS);
export type ReportValueFormat = z.infer<typeof ReportValueFormatSchema>;
